import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useDevice } from 'device'
import { CacheProvider } from 'react-cache'
import { UserProvider } from 'modules/user'
import { SubscriptionProvider } from 'modules/subscription'

import Routes from 'containers/Routes/Routes'
import ModalsRegistry from 'containers/ModalsRegistry/ModalsRegistry'

import Notifications from './components/Notifications/Notifications'
import InitialData from './components/InitialData/InitialData'
import AbFtProvider from './components/AbFtProvider/AbFtProvider'
import AnalyticsSetup from './components/AnalyticsSetup/AnalyticsSetup'
import GlobalMeta from './components/GlobalMeta/GlobalMeta'
import AppVersionChecker from './components/AppVersionChecker/AppVersionChecker'
import GlobalLoaderProvider from './components/GlobalLoaderProvider/GlobalLoaderProvider'
import PartytownSetup from './components/PartytownSetup/PartytownSetup'


type AppProps = {
  isLightweightSSR?: boolean
}

const App: React.FunctionComponent<AppProps> = ({ isLightweightSSR }) => {
  const { isBot } = useDevice()

  return (
    <>
      <Helmet>
        <title>Scentbird</title>
      </Helmet>
      {
        !isBot && (
          <>
            {/* Notifications should be rendered first to subscribe to events */}
            <Notifications />
            <AppVersionChecker />
          </>
        )
      }
      <CacheProvider>
        <InitialData isLightweightSSR={isLightweightSSR}>
          <AbFtProvider>
            <UserProvider>
              <SubscriptionProvider>
                <PartytownSetup />
                <GlobalMeta />
                {
                  !isBot && (
                    <AnalyticsSetup />
                  )
                }
                <GlobalLoaderProvider>
                  <ModalsRegistry />
                  <Routes />
                </GlobalLoaderProvider>
              </SubscriptionProvider>
            </UserProvider>
          </AbFtProvider>
        </InitialData>
      </CacheProvider>
    </>
  )
}


export default App
